<script setup lang="ts">
import { computed } from 'vue'
import { useUserStore } from '@/stores/user.ts'

const userStore = useUserStore()
const isSuperAdmin = computed<boolean>(
  () => userStore?.user?.roles.includes('ROLE_SUPER_ADMIN') ?? false,
)
</script>

<template>
  <nav class="menu-container">
    <ul>
      <li><router-link :to="{ name: 'wiser-admin' }" v-if="isSuperAdmin">Admin</router-link></li>
      <li><router-link :to="{ name: 'wiser-certificates' }">Certificaten</router-link></li>
      <li><router-link :to="{ name: 'wiser-invoices' }">Facturen</router-link></li>
      <li><router-link :to="{ name: 'wiser-offers' }">Offertes</router-link></li>
      <li><router-link :to="{ name: 'wiser-relations' }">Relaties</router-link></li>
      <li><router-link :to="{ name: 'wiser-schedules' }">Planningen</router-link></li>
    </ul>
  </nav>
</template>

<style scoped lang="scss">
nav.menu-container ul {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  li {
    flex-grow: 1;
  }
}
</style>
